
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Clock, Hash } from "lucide-react";

interface ResultsHeaderProps {
  executionTime: number;
  tokenUsage?: {
    total: number;
  };
}

export function ResultsHeader({ executionTime, tokenUsage }: ResultsHeaderProps) {
  return (
    <div className="flex items-center gap-2">
      <Badge variant="outline" className="flex gap-1">
        <Clock className="h-3 w-3" />
        {(executionTime / 1000).toFixed(2)}s
      </Badge>
      
      {tokenUsage && (
        <Badge variant="outline" className="flex gap-1">
          <Hash className="h-3 w-3" />
          {tokenUsage.total} tokens
        </Badge>
      )}
    </div>
  );
}
